export const enum DiagnosesTypeEnum {
    Tongue = 10001,
    Face = 10002,
    Taking = 10003,
    Lung = 10005,
    Phy = 10004,
    Health = 10006
}